import { render, staticRenderFns } from "./VenueRecommendedDetailed.vue?vue&type=template&id=637da18e&"
import script from "./VenueRecommendedDetailed.vue?vue&type=script&lang=js&"
export * from "./VenueRecommendedDetailed.vue?vue&type=script&lang=js&"
import style0 from "./VenueRecommendedDetailed.vue?vue&type=style&index=0&id=637da18e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports